<template>
	<div id="plate-groups" class="grided-template">
		<menu-component></menu-component>
		<div id="screen-container" class="screen-container">
			<default-header></default-header>
			<div id="panel-container">
				<collapsible-panel :panel="view.mainPanel"
				:folded="view.mainPanel.collapsed" v-if="view.mainPanel.isVisible"
				@collapsed="(collapsed) => {view.mainPanel.onChangeCollapse(collapsed); view.mainPanel.collapsed = collapsed;}"
				:class="{'collapsible-panel-fullscren': view.mainPanel.fullscreen}">
					<div class="double-grid-container">
						<grid-component
							id="groupGrid" class="half-grid"
							:grid="view.mainPanel.groupGrid.gridConfiguration"
							@update:isAddingNewRow="setAddingNewRowOnDoubleGrid(view.mainPanel.groupGrid, $event)"
						/>
						<div class="half-grid">
							<grid-component
								id="platesGrid" 
								:grid="view.mainPanel.platesGrid.gridConfiguration"
								@update:isAddingNewRow="setAddingNewRowOnDoubleGrid(view.mainPanel.platesGrid, $event)"
								@update:hasCheckedRows="(ev) => updateCheckedRows(view.mainPanel.platesGrid.gridConfiguration, ev)"
							>
							</grid-component>
							<transition name="grid-overlay-fade">
								<div class="grid-overlay" v-if="view.mainPanel.platesGrid.gridConfiguration.showLoadingOverlay || !view.mainPanel.platesGrid.gridConfiguration.hideFilterOverlay">
									<div v-if="view.mainPanel.platesGrid.gridConfiguration.showLoadingOverlay" class="grid-overlay-loading">
										<div class="grid-overlay-spinner"></div>
										<span>{{$t('loadingOoo')}}</span>
									</div>
									<span v-else>{{$t('select_a_group_of_dishes_from_the_list_on_the_side')}}</span>
								</div>
							</transition>
						</div>
					</div>


				<div class="double-grid-btn-container">
					<!-- lado esquerdo (grupo da grid da esquerda) -->
					<span class="button-div">
						<button class="button grid-button" @click="addPlateGroup"><i class="fas fa-plus"></i> {{$t('new')}}</button>
						<button class="button grid-button" @click="delPlateGroup"
								v-show="!view.mainPanel.groupGrid.gridConfiguration.isAddingNewRow">
						<i class="fas fa-trash"></i> {{$t('delete')}}
						</button>
						<button class="button grid-button"
								@click="showExportModal('GROUP', 'groupGrid', 'Exportar Grupo', true)"
								v-show="!view.mainPanel.groupGrid.gridConfiguration.isAddingNewRow">
						<i class="fas fa-file-export"></i> {{$t('export_group')}}
						</button>
						<button class="button grid-button"
								v-show="view.mainPanel.groupGrid.gridConfiguration.isAddingNewRow"
								@click="() => removeNewRowOnDoubleGrid(view.mainPanel.groupGrid)">
						<i class="fas fa-times"></i> {{$t('cancel')}}
						</button>
					</span>

					<!-- lado direito (fica abaixo da grid da direita) -->
					<span class="right-grid-button-container">
						<!-- grupo principal de botões da grid da direita -->
						<div class="button-div">
						<button class="button grid-button" @click="addPlateRegister"
								:class="{'disabled':view.mainPanel.platesGrid.gridConfiguration.disablePlateAdd || isPlatesActionsBlocked}">
							<i class="fas fa-plus"></i> {{$t('new')}}
						</button>
						<button class="button grid-button" @click="delPlateRegister"
								v-show="!view.mainPanel.platesGrid.gridConfiguration.isAddingNewRow"
								:class="{'disabled':view.mainPanel.platesGrid.gridConfiguration.disablePlateDel || isPlatesActionsBlocked}">
							<i class="fas fa-trash"></i> {{$t('delete')}}
						</button>
						<button class="button grid-button"
								@click="showExportModal('GROUP', 'platesGrid', 'Exportar Pratos', false)"
								v-show="view.mainPanel.platesGrid.gridConfiguration.hasCheckedRows && 
										!view.mainPanel.platesGrid.gridConfiguration.isAddingNewRow"
								:class="{'disabled':view.mainPanel.platesGrid.gridConfiguration.disablePlateDel || isPlatesActionsBlocked}">
							<i class="fas fa-file-export"></i> {{$t('export_dishes')}}
						</button>
						<button class="button grid-button"
								v-show="view.mainPanel.platesGrid.gridConfiguration.isAddingNewRow"
								@click="() => removeNewRowOnDoubleGrid(view.mainPanel.platesGrid)"
								:class="{'disabled':isPlatesActionsBlocked}">
							<i class="fas fa-times"></i> {{$t('cancel')}}
						</button>
						</div>

						<!-- botões “fullscreen / export” continuam à direita -->
						<div class="fullscreen-button button-div">
						<button class="button gray-button" @click="exportToExcelGroupPanel(view.mainPanel)">
							<i class="fas fa-file-excel"></i><span> {{$t('export')}} </span>
						</button>
						<button class="button gray-button" @click="invertValue(view.mainPanel,'fullscreen')">
							<div v-show="!view.mainPanel.fullscreen"><i class="fas fa-expand-arrows-alt"></i></div>
							<div v-show="view.mainPanel.fullscreen"><i class="fas fa-compress-arrows-alt"></i></div>
						</button>
						</div>
					</span>
				</div>


 				</collapsible-panel>
				<collapsible-panel :panel="view.grouplessPlatesPanel" 
				:folded="view.grouplessPlatesPanel.collapsed"
				v-if="view.grouplessPlatesPanel.isVisible"
				@collapsed="(v) => sync(v, view.grouplessPlatesPanel, 'collapsed')"
				:class="{'collapsible-panel-fullscren': view.grouplessPlatesPanel.fullscreen}">
					<div class="grid-container">
					<grid-component
						class="low-height-grid"
						id="parametersGrid"
						:grid="view.grouplessPlatesPanel.gridConfiguration"
						@update:hasCheckedRows="(ev) => updateCheckedRows(view.grouplessPlatesPanel, ev)"
					></grid-component>
					<div class="button-container">
						<div class="button-div">
							<button
								class="button grid-button"
								@click="openLinkGrouplessPlatesModal"
							>
								<i class="fas fa-link"></i> {{$t('plate_group_link_action')}}
							</button>
						</div>
						<div class="button-container-align-right full-width">
							<button class="button gray-button" @click="exportToExcel(view.grouplessPlatesPanel)">
								<i class="fas fa-file-excel"></i>
									<span> {{$t('export')}} </span> 
								</button>
								<button class="button gray-button" 
								@click="invertValue(view.grouplessPlatesPanel,'fullscreen')">
										<span v-show="!view.grouplessPlatesPanel.fullscreen">
											<i class="fas fa-expand-arrows-alt"></i>
										</span>
										<span v-show="view.grouplessPlatesPanel.fullscreen">
											<i class="fas fa-compress-arrows-alt"></i>
										</span>
								</button>
							</div>
						</div>
					</div>
 				</collapsible-panel>
				<collapsible-panel :panel="view.plateGroupGroupingPanel" 
				:folded="view.plateGroupGroupingPanel.collapsed"
				v-if="view.plateGroupGroupingPanel.isVisible"
				@collapsed="(v) => sync(v, view.plateGroupGroupingPanel, 'collapsed')"
				:class="{'collapsible-panel-fullscren': view.plateGroupGroupingPanel.fullscreen}">
					<div class="grid-container">
						<grid-component
							class="low-height-grid"
							id="parametersGrid"
							:grid="view.plateGroupGroupingPanel.gridConfiguration"
							@update:isAddingNewRow="updateIsAddingNewRow(view.plateGroupGroupingPanel, $event)"
							@update:hasCheckedRows="(ev) => updateCheckedRows(view.plateGroupGroupingPanel, ev)"
						></grid-component>
					</div>
					<div class="button-container">
						<div class="button-div">
							<button class="button grid-button" @click="addPlateGroupGroupingRow">
								<i class="fas fa-plus"></i> {{$t('new')}} </button>
							<button class="button grid-button" 
								v-show="view.plateGroupGroupingPanel.hasCheckedRows &&
								!view.plateGroupGroupingPanel.isAddingNewRow"
								@click="callController('deletePlateGroupGrouping', [view.plateGroupGroupingPanel])"> 
							<i class="fas fa-trash"></i> {{$t('delete')}} </button>
							<button class="button grid-button"
							v-show="view.plateGroupGroupingPanel.isAddingNewRow"
							@click="() => removeNewRow(view.plateGroupGroupingPanel)">
								<i class="fas fa-times"></i> {{$t('cancel')}} </button>
						</div>
						<div class="button-container-align-right">
							<button class="button gray-button" @click="exportToExcel(view.plateGroupGroupingPanel)">
								<i class="fas fa-file-excel"></i>
								<span> {{$t('export')}} </span> 
							</button>
							<button class="button gray-button" 
							@click="invertValue(view.plateGroupGroupingPanel,'fullscreen')">
								<span v-show="!view.plateGroupGroupingPanel.fullscreen">
									<i class="fas fa-expand-arrows-alt"></i>
								</span>
								<span v-show="view.plateGroupGroupingPanel.fullscreen">
									<i class="fas fa-compress-arrows-alt"></i>
								</span>
							</button>
						</div>
					</div>
 				</collapsible-panel>
				<collapsible-panel :panel="view.plateGroupStandardPanel" 
				:folded="view.plateGroupStandardPanel.collapsed" v-if="view.plateGroupStandardPanel.isVisible"
				@collapsed="(v) => sync(v, view.plateGroupStandardPanel, 'collapsed')"
				:class="{'collapsible-panel-fullscren': view.plateGroupStandardPanel.fullscreen}">
					<div class="grid-container">
						<grid-component
							class="low-height-grid"
							id="parametersGrid"
							:grid="view.plateGroupStandardPanel.gridConfiguration"
							@update:isAddingNewRow="updateIsAddingNewRow(view.plateGroupStandardPanel, $event)"
							@update:hasCheckedRows="(ev) => updateCheckedRows(view.plateGroupStandardPanel, ev)"
						></grid-component>
					</div>
					<div class="button-container">
						<div class="button-div">
							<button class="button grid-button" @click="addPlateGroupStandardRow">
								<i class="fas fa-plus"></i> {{$t('new')}} </button>
							<button class="button grid-button" 
								v-show="view.plateGroupStandardPanel.hasCheckedRows &&
								!view.plateGroupStandardPanel.isAddingNewRow"
								@click="callController('deletePlateGroupStandard', [view.plateGroupStandardPanel])"> 
							<i class="fas fa-trash"></i> {{$t('delete')}} </button>
							<button class="button grid-button"
							v-show="view.plateGroupStandardPanel.isAddingNewRow"
							@click="() => removeNewRow(view.plateGroupStandardPanel)">
								<i class="fas fa-times"></i> {{$t('cancel')}} </button>
						</div>
						<div class="button-container-align-right">
							<button class="button gray-button" @click="exportToExcel(view.plateGroupStandardPanel)">
								<i class="fas fa-file-excel"></i>
								<span> {{$t('export')}} </span> 
							</button>
							<button class="button gray-button" 
							@click="invertValue(view.plateGroupStandardPanel,'fullscreen')">
								<span v-show="!view.plateGroupStandardPanel.fullscreen">
									<i class="fas fa-expand-arrows-alt"></i>
								</span>
								<span v-show="view.plateGroupStandardPanel.fullscreen">
									<i class="fas fa-compress-arrows-alt"></i>
								</span>
							</button>
						</div>
					</div>
 				</collapsible-panel>
			</div>
		</div>

		<modal name="recipe-modal" @opened="view.recipeModal.onOpenModal">
			<grid-component
				class="recipe-grid"
				id="recipeGrid"
				:grid="view.recipeModal.gridConfiguration"
			></grid-component>
		</modal>
			<filter-action-modal
				name="add-plates-modal"
				@opened="onAddPlatesModalOpened"
				:clickToClose="false"
				:title="$t('plate_group_select_plates_title')"
				:filterPlaceholder="$t('plate_group_search_plate_placeholder')"
				:filterValue="view.addPlatesModal.search"
				:filterButtonLabel="$t('searchOoo')"
				:filterButtonDisabled="view.addPlatesModal.saving"
				:cancelLabel="$t('back')"
				:confirmLabel="$t('save')"
				:cancelDisabled="view.addPlatesModal.saving"
				:confirmDisabled="view.addPlatesModal.saving || !view.addPlatesModal.selectedCount"
				:selectedCount="view.addPlatesModal.selectedCount"
				:grid="view.addPlatesModal.gridConfiguration"
				gridId="addPlatesModalGrid"
				gridClass="add-plates-modal-grid"
				@update:filterValue="(value) => view.addPlatesModal.search = value"
			@search="fetchAddPlatesList"
			@cancel="closeAddPlatesModal"
			@confirm="saveSelectedPlates"
		></filter-action-modal>
		<filter-action-modal
			name="link-groupless-plates-modal"
			@opened="onLinkGrouplessModalOpened"
			:clickToClose="false"
			:title="$t('plate_group_link_groupless_title')"
			:filterPlaceholder="$t('plate_group_link_groupless_search_placeholder')"
			:filterValue="view.linkGrouplessModal.search"
			:filterButtonLabel="$t('searchOoo')"
			:filterButtonDisabled="view.linkGrouplessModal.loading || view.linkGrouplessModal.saving"
			:cancelLabel="$t('back')"
			:confirmLabel="$t('save')"
			:cancelDisabled="view.linkGrouplessModal.saving"
			:confirmDisabled="view.linkGrouplessModal.saving || view.linkGrouplessModal.selectedGroupCount !== 1"
			:overlayLoading="view.linkGrouplessModal.saving"
			:overlayLoadingLabel="$t('loadingOoo')"
			:selectedCount="view.linkGrouplessModal.selectedGroupCount"
			:grid="view.linkGrouplessModal.gridConfiguration"
			gridId="linkGrouplessPlatesGrid"
			gridClass="link-groupless-modal-grid"
			@update:filterValue="(value) => view.linkGrouplessModal.search = value"
			@search="fetchLinkGrouplessGroups"
			@cancel="closeLinkGrouplessPlatesModal"
			@confirm="saveLinkGrouplessPlates"
		></filter-action-modal>
	<transition name="floating-loader-fade">
			<div class="add-plates-floating-loader" v-if="view.addPlatesModal.backgroundLoading">
				<div class="loader-dot"></div>
				<span>{{view.addPlatesModal.backgroundLoadingMessage}}</span>
			</div>
		</transition>
		<modal
			name="export-form-modal" 
			:height="'auto'" 
			:clickToClose="false"
		>
			<export-form
				:modal="$modal"
				:name="view.exportDataModal._name"
				:modalStyle="view.exportDataModal._style"
				:showLoad="view.exportDataModal._showLoad"
				:showMultiGroup="view.exportDataModal._multiGroup"
				@saveExport="saveExport"
			/>
		</modal>
	</div>
</template>

<script>
import PlateGroupsController from '../controllers/PlateGroupsController'

import MenuComponent from '@/components/src/MenuComponent';
import DefaultHeader from '@/components/src/DefaultHeaderComponent';
import CollapsiblePanel from '@/components/src/CollapsiblePanelComponent';
import Grid from "@/components/src/GridComponent";
import eventModule from '@/application/libs/eventModule';
import Util from '@/application/libs/util';
import ExcelBuilder from  '@/application/libs/excelBuilder'
import permissionManager from "@/application/libs/permissionManager"
import ExportForm from '@/components/src/ExportForm'
import FilterActionModal from '@/components/src/modals/FilterActionModal'
import PlateGroupsService from '@/application/services/PlateGroups'
import { t } from 'i18next'

export default {
	name: "Plates",
	components:{
		'menu-component':MenuComponent,
		'default-header':DefaultHeader,
		'collapsible-panel':CollapsiblePanel,
		'grid-component': Grid,
		'export-form': ExportForm,
		'filter-action-modal': FilterActionModal
	},
	data() {
		return {
			view: {
				title: t('group_of_dishes'),
				plateGroupStandardPanel:{
					title: t('dish_group_pattern'),
					name:"plateGroupStandardPanel",
					gridConfiguration : PlateGroupsController.plateGroupStandardGridConfig,
					collapsed: true,
					hasCheckedRows: false,
					fullscreen: false,
					isAddingNewRow: false,
					isVisible: true,
					info: t('info_dish_group_pattern')
				},
				plateGroupGroupingPanel:{
					title: t('dish_group_grouping'),
					name:"plateGroupGroupingPanel",
					gridConfiguration : PlateGroupsController.plateGroupGroupingGridConfig,
					collapsed: true,
					hasCheckedRows: false,
					fullscreen: false,
					isAddingNewRow: false,
					isVisible: true,
					info: t('info_dish_group_grouping') + `\n` + t('info_2_dish_group_grouping')
				},
				grouplessPlatesPanel:{
					title: t('dishes_not_linked_to_dish_group'),
					name:"grouplessPlatesPanel",
					gridConfiguration : PlateGroupsController.grouplessPlatesGridConfig,
					hasCheckedRows: false,
					collapsed: true,
					fullscreen: false,
					isVisible: true,
					info: t('info_dishes_not_linked_to_dish_group') + `\n` + t('info_2_dishes_not_linked_to_dish_group')
				},
				mainPanel:{
					collapsed:false,
					fullscreen:false,
					isVisible: true,
					title: t('group_of_dishes'),
					name:"plateGroup",
					info: t('info_group_of_dishes') + `\n` + t('info_2_group_of_dishes') + `\n` + t('info_3_group_of_dishes') + `\n` + t('info_4_group_of_dishes') + `\n` + t('info_5_group_of_dishes') ,
					onChangeCollapse:PlateGroupsController.onChangeMainPanelCollapse,
					groupGrid:{
						gridConfiguration: Object.assign(PlateGroupsController.groupGridConfiguration, {
							isAddingNewRow: false
						})
					},
					platesGrid:{
						gridConfiguration: Object.assign(PlateGroupsController.platesGridConfiguration, {
							hideFilterOverlay:false,
							showLoadingOverlay:false,
							disablePlateAdd:true,
							disablePlateDel:true,
							isAddingNewRow: false,
							hasCheckedRows: false
						})
					},
				},
				recipeModal:{
					gridConfiguration:PlateGroupsController.recipeGrid,
					onOpenModal:()=>{
						let recipeGrid = this.view.recipeModal.gridConfiguration;
						recipeGrid.setRowData(recipeGrid.__data);
						delete recipeGrid.__data;
					}
				},
				addPlatesModal: {
					gridConfiguration: {
						defaultColDef: {
							resizable: true,
							lockVisible: true,
							editable: false,
							sortable: true,
							filter: true
						},
						columnDefs: [
							{
								headerValueGetter: () => t('tree'),
								field: 'CDFILAUXPRAT',
								maxWidth: 120,
								checkboxSelection: true,
								headerCheckboxSelection: true,
								headerCheckboxSelectionFilteredOnly: true
							},
							{
								headerValueGetter: () => t('code'),
								field: 'CDPRATO',
								maxWidth: 120
							},
							{
								headerValueGetter: () => t('name'),
								field: 'NMPRATO',
								minWidth: 380
							}
						],
						rowSelection: 'multiple',
						suppressRowClickSelection: true,
						onRowClicked: (params) => {
							const alreadySelected = params.node.isSelected();
							params.node.setSelected(!alreadySelected, false);
						},
						onSelectionChanged: (params) => {
							this.syncAddPlatesSelectionCache(params && params.api);
						}
					},
					plates: [],
					selectedPlatesByKey: {},
					search: '',
					selectedCount: 0,
					loading: false,
					saving: false,
					backgroundLoading: false,
					backgroundLoadingMessage: ''
				},
				linkGrouplessModal: {
					search: '',
					groups: [],
					selectedGroup: null,
					isRefreshingGridData: false,
					selectedGroupCount: 0,
					loading: false,
					saving: false,
					gridConfiguration: {
						defaultColDef: {
							resizable: true,
							lockVisible: true,
							editable: false,
							sortable: true,
							filter: true
						},
						columnDefs: [
							{
								headerValueGetter: () => t('group_code'),
								field: 'CDGRUPOPRATO',
								checkboxSelection: true,
								maxWidth: 140
							},
							{
								headerValueGetter: () => t('group'),
								field: 'NMGRUPOPRATO',
								minWidth: 260
							},
							{
								headerValueGetter: () => t('groupings'),
								field: 'NMAGRUPGRPRAT',
								minWidth: 220
							}
						],
						rowSelection: 'single',
						suppressRowClickSelection: true,
						onRowClicked: (params) => {
							const alreadySelected = params.node.isSelected();
							params.node.setSelected(!alreadySelected, false);
						},
						onSelectionChanged: (params) => {
							this.syncLinkGrouplessSelectionCache(params && params.api);
						}
					}
				},
				exportDataModal: {
					_showLoad: true
				}
			}
		};
	},
	created(){
		eventModule.$on("updateBoData", this.refreshPlateGroupViewGrids);
		PlateGroupsController.CDPICTPRAT = Util.getFilterInSession().CDPICTPRAT;
		PlateGroupsController.CDPICTPROD = Util.getFilterInSession().CDPICTPROD;
		const permissions = permissionManager.getPlateGroupsViewPermissions();
		Object.keys(permissions).forEach(panelName => this.view[panelName].isVisible = permissions[panelName]);
		// let colDef = PlateGroupsController.grouplessPlatesGridConfig.columnDefs.find(cd => cd.field === 'CDPRATO');
		// colDef.valueFormatter = Util.maskFactory(PlateGroupsController.CDPICTPRAT); 
	},
	mounted() {
		document.title = `${this.view.title} - Cardápio Inteligente`;

		// let platesGrid = this.view.mainPanel.platesGrid;
		// let groupGrid = this.view.mainPanel.groupGrid;
		PlateGroupsController.vueContext = this;
		// groupGrid.gridConfiguration.advancedOptions.onRowClicked = PlateGroupsController.onGroupRowClicked;
		// groupGrid.gridConfiguration.advancedOptions.onSelectionChanged = PlateGroupsController.removeNewRowOnRowDeselection;
		
		// platesGrid.gridConfiguration.advancedOptions.onRowDoubleClicked = (params)=>PlateGroupsController.onPlateRowDbClicked(params, this);
		// platesGrid.gridConfiguration.advancedOptions.onSelectionChanged = PlateGroupsController.removeNewRowOnRowDeselection;
		
	},
	beforeDestroy(){
		eventModule.$off("updateBoData", this.refreshPlateGroupViewGrids);
	},
	computed: {
		isPlatesActionsBlocked(){
			const platesGrid = this.view.mainPanel.platesGrid.gridConfiguration;
			return !!(platesGrid.showLoadingOverlay || this.view.addPlatesModal.backgroundLoading);
		}
	},
	methods: {
		sync: (v, obj, propName) =>  obj[propName] = v,
		addPlateGroupGroupingRow: function(){PlateGroupsController.plateGroupGroupingGridConfig.addNewRowToGrid()},
		addPlateGroupStandardRow: function(){PlateGroupsController.plateGroupStandardGridConfig.addNewRowToGrid()},
		callController: function(methodName, params = []) {
			return PlateGroupsController[methodName] && PlateGroupsController[methodName](...params);
		},
		addPlateGroup(){
			this.view.mainPanel.groupGrid.gridConfiguration.addNewRowToGrid(true, true, false);
		},
		delPlateGroup: function(params){
			PlateGroupsController.delPlateGroup(params, this.$modal);
		},
		invertValue: function(object, key){
			object[key] = !object[key];
		},
		addPlateRegister(){
			if(this.view.mainPanel.platesGrid.gridConfiguration.disablePlateAdd || this.isPlatesActionsBlocked){
				return;
			}

			const selectedGroup = this.getSelectedGroup();
			if(!selectedGroup){
				this.showPlateGroupSelectionError();
				return;
			}

			this.resetAddPlatesModalData();
			this.openAddPlatesModal();
		},
		onAddPlatesModalOpened(){
			this.fetchAddPlatesList();
		},
		delPlateRegister(){
			if(this.isPlatesActionsBlocked || this.view.mainPanel.platesGrid.gridConfiguration.disablePlateDel){
				return;
			}

			PlateGroupsController.delPlateRegister();
		},
		showPlateGroupSelectionError(){
			Util.showErrorNotification({
				title: t('unable_to_save_dish_group'),
				text: t('select_a_group_of_dishes_from_the_list_on_the_side')
			});
		},
		getSelectedGroup(){
			const groupGridApi = this.view.mainPanel.groupGrid.gridConfiguration.gridControl;
			if(!groupGridApi){
				return null;
			}

			const selectedRows = groupGridApi.getSelectedRows();
			return (selectedRows && selectedRows[0]) || null;
		},
			openAddPlatesModal(){
				this.$modal.show('add-plates-modal', {}, {
					height: 'auto',
					width: '60%'
				});
			},
			openLinkGrouplessPlatesModal(){
				if(this.view.linkGrouplessModal.saving){
					return;
				}

				if(!this.view.grouplessPlatesPanel.hasCheckedRows){
					Util.showErrorNotification({
						title: t('unable_to_save_dish_group'),
						text: t('no_record_selected')
					});
					return;
				}

				this.resetLinkGrouplessModalData();
				this.$modal.show('link-groupless-plates-modal', {}, {
					height: 'auto',
					width: '60%'
				});
			},
			onLinkGrouplessModalOpened(){
				this.fetchLinkGrouplessGroups();
			},
			closeLinkGrouplessPlatesModal(){
				if(this.view.linkGrouplessModal.saving){
					return;
				}

				this.resetLinkGrouplessModalData();
				this.$modal.hide('link-groupless-plates-modal');
			},
			closeAddPlatesModal(){
				if(this.view.addPlatesModal.saving){
					return;
				}

			this.resetAddPlatesModalData();
			this.$modal.hide('add-plates-modal');
		},
		getPlatesGridConfiguration(){
			return this.view.mainPanel.platesGrid.gridConfiguration;
		},
		getGridApi(gridConfiguration){
			return gridConfiguration?.advancedOptions?.api || null;
		},
		setGridRowData(gridConfiguration, rows){
			if(gridConfiguration?.setRowData){
				gridConfiguration.setRowData(rows);
			}
		},
		showGridLoadingOverlay(gridConfiguration){
			const gridApi = this.getGridApi(gridConfiguration);
			if(gridApi?.showLoadingOverlay){
				gridApi.showLoadingOverlay();
			}
		},
		showGridNoRowsOverlay(gridConfiguration){
			const gridApi = this.getGridApi(gridConfiguration);
			if(gridApi?.showNoRowsOverlay){
				gridApi.showNoRowsOverlay();
			}
		},
		hideGridOverlay(gridConfiguration){
			const gridApi = this.getGridApi(gridConfiguration);
			if(gridApi?.hideOverlay){
				gridApi.hideOverlay();
			}
		},
			resetAddPlatesModalData(){
				this.view.addPlatesModal.search = '';
				this.view.addPlatesModal.plates = [];
				this.view.addPlatesModal.selectedPlatesByKey = {};
				this.view.addPlatesModal.selectedCount = 0;

				const modalGrid = this.view.addPlatesModal.gridConfiguration;
				if(modalGrid.setRowData){
					modalGrid.setRowData([]);
				}
			},
			resetLinkGrouplessModalData(){
				this.view.linkGrouplessModal.search = '';
				this.view.linkGrouplessModal.groups = [];
				this.view.linkGrouplessModal.selectedGroup = null;
				this.view.linkGrouplessModal.isRefreshingGridData = false;
				this.view.linkGrouplessModal.selectedGroupCount = 0;

				const modalGrid = this.view.linkGrouplessModal.gridConfiguration;
				if(modalGrid.setRowData){
					modalGrid.setRowData([]);
				}
			},
			getSelectedGrouplessPlates(){
				const gridApi = this.view.grouplessPlatesPanel.gridConfiguration.gridControl;
				if(!gridApi || !gridApi.getSelectedRows){
					return [];
				}

				return gridApi.getSelectedRows() || [];
			},
			getSelectedGroupFromLinkModal(){
				return this.view.linkGrouplessModal.selectedGroup || null;
			},
			filterLinkGroupsBySearch(groups, search){
				if(!search){
					return groups;
				}

				const normalizedSearch = String(search).trim().toLowerCase();
				if(!normalizedSearch){
					return groups;
				}

				return groups.filter((group) => {
					const source = [group.CDGRUPOPRATO, group.NMGRUPOPRATO, group.NMAGRUPGRPRAT]
						.filter(Boolean)
						.join(' ')
						.toLowerCase();

					return source.includes(normalizedSearch);
				});
			},
			async fetchLinkGrouplessGroups(){
				const modalGrid = this.view.linkGrouplessModal.gridConfiguration;
				this.view.linkGrouplessModal.loading = true;
				this.showGridLoadingOverlay(modalGrid);

				try {
					this.view.linkGrouplessModal.isRefreshingGridData = true;
					const rawGroups = await PlateGroupsService.getGroupsForGrouplessPlates();
					const groups = Array.isArray(rawGroups) ? rawGroups : [];
					const filteredGroups = this.filterLinkGroupsBySearch(groups, this.view.linkGrouplessModal.search);

					this.view.linkGrouplessModal.groups = filteredGroups;
					this.setGridRowData(modalGrid, filteredGroups);

					this.restoreLinkGrouplessSelection(this.getGridApi(modalGrid));

					if(!filteredGroups.length){
						this.showGridNoRowsOverlay(modalGrid);
					} else {
						this.hideGridOverlay(modalGrid);
					}
				} catch {
					this.view.linkGrouplessModal.groups = [];
					this.setGridRowData(modalGrid, []);
					this.showGridNoRowsOverlay(modalGrid);

					Util.showErrorNotification({
						title: t('unable_to_save_dish_group'),
						text: t('plate_group_unable_to_load_groups_to_link')
					});
				} finally {
					this.view.linkGrouplessModal.isRefreshingGridData = false;
					this.view.linkGrouplessModal.loading = false;
				}
			},
			async saveLinkGrouplessPlates(){
				const selectedPlates = this.getSelectedGrouplessPlates();
				if(!selectedPlates.length){
					Util.showErrorNotification({
						title: t('unable_to_save_dish_group'),
						text: t('no_record_selected')
					});
					return;
				}

				const selectedGroup = this.getSelectedGroupFromLinkModal();
				if(!selectedGroup || !selectedGroup.NRGRUPOPRATOSERV){
					Util.showErrorNotification({
						title: t('unable_to_save_dish_group'),
						text: t('plate_group_select_one_target_group')
					});
					return;
				}

				this.view.linkGrouplessModal.saving = true;

				try {
					const results = await Promise.allSettled(
						selectedPlates.map((plate) => PlateGroupsService.saveGrouplessPlates({
							...plate,
							NRGRUPOPRATOSERV: selectedGroup.NRGRUPOPRATOSERV
						}))
					);

					const failedCount = results.filter((result) => {
						if(result.status === 'rejected'){
							return true;
						}

						return !!(result.value && result.value.error);
					}).length;

					await this.view.grouplessPlatesPanel.gridConfiguration.reloadData();
					this.view.grouplessPlatesPanel.hasCheckedRows = false;
					this.view.linkGrouplessModal.saving = false;
					this.closeLinkGrouplessPlatesModal();
					await this.$nextTick();

					if(failedCount){
						Util.showErrorNotification({
							title: t('unable_to_save_dish_group'),
							text: t('plate_group_records_not_saved_count', { count: failedCount })
						});
					} else {
						Util.showSuccessNotification({
							title: t('linked_dish'),
							text: ''
						});
					}
				} catch {
					Util.showErrorNotification({
						title: t('unable_to_save_dish_group'),
						text: t('plate_group_error_linking_multiple_plates')
					});
				} finally {
					this.view.linkGrouplessModal.saving = false;
				}
			},
		setPlateGridEnabledState(grid){
			grid.hideFilterOverlay = true;
			grid.disablePlateAdd = false;
			grid.disablePlateDel = false;
		},
			getSelectedPlatesFromModal(){
				return Object.values(this.view.addPlatesModal.selectedPlatesByKey || {});
			},
			syncAddPlatesSelectionCache(api){
				if(!api || !api.getSelectedRows || !api.forEachNode){
					return;
				}

				const selectedRowsByKey = (api.getSelectedRows() || []).reduce((acc, row) => {
					acc[this.buildPlateKey(row)] = row;
					return acc;
				}, {});

				const nextSelectedByKey = { ...(this.view.addPlatesModal.selectedPlatesByKey || {}) };
				api.forEachNode((node) => {
					if(!node || !node.data){
						return;
					}
					const key = this.buildPlateKey(node.data);
					delete nextSelectedByKey[key];
				});

				Object.assign(nextSelectedByKey, selectedRowsByKey);
				this.view.addPlatesModal.selectedPlatesByKey = nextSelectedByKey;
				this.view.addPlatesModal.selectedCount = Object.keys(nextSelectedByKey).length;
			},
			restoreAddPlatesSelection(api){
				if(!api || !api.forEachNode){
					return;
				}

				const selectedByKey = this.view.addPlatesModal.selectedPlatesByKey || {};
				api.forEachNode((node) => {
					if(!node || !node.data){
						return;
					}
					const key = this.buildPlateKey(node.data);
					node.setSelected(Boolean(selectedByKey[key]), false);
				});
				this.view.addPlatesModal.selectedCount = Object.keys(selectedByKey).length;
			},
		buildOptimisticRows(selectedPlates, currentRows){
			const selectedKeys = new Set(selectedPlates.map((plate) => this.buildPlateKey(plate)));
			const selectedRows = selectedPlates.map((plate) => ({
				...plate,
				NRITGRUPOPRATOSERV: plate.NRITGRUPOPRATOSERV || null
			}));

			return {
				selectedKeys,
				rows: selectedRows.concat(currentRows.filter((row) => !selectedKeys.has(this.buildPlateKey(row))))
			};
		},
		buildRowsWithSelectedOnTop(freshRows, selectedPlates, selectedKeys){
			const rowByKey = new Map(freshRows.map((row) => [this.buildPlateKey(row), row]));
			const selectedRowsOnTop = selectedPlates
				.map((plate) => rowByKey.get(this.buildPlateKey(plate)))
				.filter(Boolean);
			const restRows = freshRows.filter((row) => !selectedKeys.has(this.buildPlateKey(row)));

			return [...selectedRowsOnTop, ...restRows];
		},
		handleSaveSelectedPlatesResult(results){
			const failedCount = results.filter((result) => result.status === 'rejected').length;

			if(failedCount){
				Util.showErrorNotification({
					title: t('unable_to_save_dish_group'),
					text: t('plate_group_records_not_saved_count', { count: failedCount })
				});
				return;
			}

			Util.showSuccessNotification({
				title: t('record_inserted_successfully'),
				text: ''
			});
		},
			buildPlateKey(plate){
				return `${plate.CDFILAUXPRAT || ''}-${plate.CDPRATO || ''}`;
			},
			buildLinkGroupKey(group){
				if(!group){
					return '';
				}

				return String(group.NRGRUPOPRATOSERV || group.CDGRUPOPRATO || group.NMGRUPOPRATO || '');
			},
			findNodeByKey(api, key, keyBuilder){
				if(!api || !api.forEachNode || !key){
					return null;
				}

				let foundNode = null;
				api.forEachNode((node) => {
					if(!foundNode && node?.data && keyBuilder(node.data) === key){
						foundNode = node;
					}
				});

				return foundNode;
			},
			syncLinkGrouplessSelectionCache(api){
				if(!api || !api.getSelectedRows || !api.forEachNode){
					return;
				}

				const selectedRows = api.getSelectedRows() || [];
				const selectedRow = selectedRows[0] || null;
				if(selectedRow){
					this.view.linkGrouplessModal.selectedGroup = selectedRow;
					this.view.linkGrouplessModal.selectedGroupCount = 1;
					return;
				}

				if(this.view.linkGrouplessModal.isRefreshingGridData){
					this.view.linkGrouplessModal.selectedGroupCount = this.view.linkGrouplessModal.selectedGroup ? 1 : 0;
					return;
				}

				const selectedGroup = this.view.linkGrouplessModal.selectedGroup;
				if(!selectedGroup){
					this.view.linkGrouplessModal.selectedGroupCount = 0;
					return;
				}

				const selectedKey = this.buildLinkGroupKey(selectedGroup);
				const selectedVisibleNode = this.findNodeByKey(api, selectedKey, this.buildLinkGroupKey);

				if(selectedVisibleNode){
					this.view.linkGrouplessModal.selectedGroup = null;
					this.view.linkGrouplessModal.selectedGroupCount = 0;
					return;
				}

				this.view.linkGrouplessModal.selectedGroupCount = 1;
			},
			restoreLinkGrouplessSelection(api){
				if(!api || !api.forEachNode){
					return;
				}

				const selectedGroup = this.view.linkGrouplessModal.selectedGroup;
				if(!selectedGroup){
					this.view.linkGrouplessModal.selectedGroupCount = 0;
					return;
				}

				const selectedKey = this.buildLinkGroupKey(selectedGroup);
				const targetNode = this.findNodeByKey(api, selectedKey, this.buildLinkGroupKey);

				api.deselectAll();
				if(targetNode){
					targetNode.setSelected(true, false);
				}
				this.view.linkGrouplessModal.selectedGroupCount = 1;
			},
			async fetchAddPlatesList(){
				const modalGrid = this.view.addPlatesModal.gridConfiguration;
				this.view.addPlatesModal.loading = true;
				this.showGridLoadingOverlay(modalGrid);

				const search = this.view.addPlatesModal.search || '';

				try {
					this.syncAddPlatesSelectionCache(this.getGridApi(modalGrid));

					const plates = await PlateGroupsService.getNewPlatesToAdd(search);
					this.view.addPlatesModal.plates = Array.isArray(plates) ? plates : [];
					this.setGridRowData(modalGrid, this.view.addPlatesModal.plates);

					this.restoreAddPlatesSelection(this.getGridApi(modalGrid));

					if(!this.view.addPlatesModal.plates.length){
						this.showGridNoRowsOverlay(modalGrid);
					} else {
						this.hideGridOverlay(modalGrid);
					}
				} catch {
					this.view.addPlatesModal.plates = [];
					this.setGridRowData(modalGrid, []);
					this.showGridNoRowsOverlay(modalGrid);

				Util.showErrorNotification({
					title: t('unable_to_save_dish_group'),
					text: t('plate_group_unable_to_load_plates_to_add')
				});
			} finally {
				this.view.addPlatesModal.loading = false;
			}
		},
		async saveSelectedPlates(){
			const selectedGroup = this.getSelectedGroup();
			if(!selectedGroup){
				this.showPlateGroupSelectionError();
				return;
			}

			const selectedPlates = this.getSelectedPlatesFromModal();
			if(!selectedPlates.length){
				Util.showErrorNotification({
					title: t('unable_to_save_dish_group'),
					text: t('no_record_selected')
				});
				return;
			}

			this.view.addPlatesModal.saving = true;
			this.view.addPlatesModal.backgroundLoading = true;
			this.view.addPlatesModal.backgroundLoadingMessage = t('plate_group_including_plates_background');
			this.$modal.hide('add-plates-modal');

			const plateGrid = this.getPlatesGridConfiguration();
			const currentRows = plateGrid.getRowData() || [];
			const optimisticRowsData = this.buildOptimisticRows(selectedPlates, currentRows);
			plateGrid.setRowData(optimisticRowsData.rows);
			this.setPlateGridEnabledState(plateGrid);

			try {
				const results = await Promise.allSettled(
					selectedPlates.map((plate) => PlateGroupsService.saveNewPlate(plate, selectedGroup))
				);
				this.handleSaveSelectedPlatesResult(results);

				const data = await PlateGroupsService.getPlatesByGroup(selectedGroup.NRGRUPOPRATOSERV);
				const freshRows = Array.isArray(data) ? data : [];
				const finalRows = this.buildRowsWithSelectedOnTop(
					freshRows,
					selectedPlates,
					optimisticRowsData.selectedKeys
				);

				plateGrid.setRowData(finalRows);
				this.setPlateGridEnabledState(plateGrid);
			} catch {
				Util.showErrorNotification({
					title: t('unable_to_save_dish_group'),
					text: t('plate_group_error_refreshing_plates_grid_after_add')
				});
			} finally {
				this.view.addPlatesModal.saving = false;
				this.view.addPlatesModal.backgroundLoading = false;
				this.view.addPlatesModal.backgroundLoadingMessage = '';
				this.resetAddPlatesModalData();
			}
		},
		refreshPlateGroupViewGrids(ev){
			let contractTypeHasChanged = ev.oldValue.TPCONTRATO !== ev.newValue.TPCONTRATO;

			!this.view.grouplessPlatesPanel.collapsed && this.view.grouplessPlatesPanel.gridConfiguration.reloadData();
			
			if(!this.view.plateGroupGroupingPanel.collapsed && contractTypeHasChanged){
				 this.view.plateGroupGroupingPanel.gridConfiguration.reloadData();
			}
			if(!this.view.plateGroupStandardPanel.collapsed && contractTypeHasChanged){ 
				this.view.plateGroupStandardPanel.gridConfiguration.reloadData();
			}

			if(!this.view.mainPanel.collapsed){
				let groupGrid = this.view.mainPanel.groupGrid;
				groupGrid.gridConfiguration.reloadData();
			}
		},
		updateCheckedRows: function(panel, value){
			if(panel.isAddingNewRow){
				let selectedRows = panel.gridConfiguration.advancedOptions.api.getSelectedRows(); 
				panel.hasCheckedRows = (selectedRows.length && (selectedRows.length > 1 || !selectedRows[0].__is_new_row)); 
			} else {
				panel.hasCheckedRows = value;
			}
		},
		updateIsAddingNewRow: function(panel, value){
			panel.isAddingNewRow = value;
			!value && panel.gridConfiguration.enableSelection && panel.gridConfiguration.enableSelection();
		},
		setAddingNewRowOnDoubleGrid: function(grid, value){
			grid.gridConfiguration.isAddingNewRow = value;
			!value && grid.gridConfiguration.enableSelection && grid.gridConfiguration.enableSelection();
		},
		removeNewRow: function(panel){
			let rows = panel.gridConfiguration.getRowData();
			rows[0] && rows[0].__is_new_row && (rows[0].__removed = true) && rows.shift();
			panel.gridConfiguration.setRowData(rows);
			panel.gridConfiguration.enableSelection();
			panel.isAddingNewRow = false;
			panel.hasCheckedRows = false;
		},
		removeNewRowOnDoubleGrid: function(grid){
			let rows = grid.gridConfiguration.getRowData();
			rows[0] && rows[0].__is_new_row && (rows[0].__removed = true) && rows.shift();
			grid.gridConfiguration.setRowData(rows);
			grid.gridConfiguration.enableSelection();
			grid.gridConfiguration.isAddingNewRow = false;
			grid.gridConfiguration.hasCheckedRows = false;
		},
		exportToExcel: function(view){
			ExcelBuilder.fromJson(
				Util.getVisibleDataFromGrid(view.gridConfiguration),
				Util.getGridColDefsToColDetails(view.gridConfiguration.columnDefs),
				view.title,
				Util.getExcelHeaderFromFilter(),
			);
		},
		exportToExcelGroupPanel: function(mainPanel) {
			PlateGroupsController.exportGroupPlate().then((response) => {
				const columnDefs = [];
				mainPanel.groupGrid.gridConfiguration.columnDefs.forEach((data) => { columnDefs.push(data) });
				mainPanel.platesGrid.gridConfiguration.columnDefs.forEach((data) => { columnDefs.push(data) });
				ExcelBuilder.fromJson(
					response,
					Util.getGridColDefsToColDetails(columnDefs),
					mainPanel.title,
					Util.getExcelHeaderFromFilter(),
				);
			});
		},
		showExportModal: function(modalStyle, caller, name, multiGroup) {
			const configuration = this.getGridConfiguration(caller);
			if(configuration.table == "ITGRUPOPRATO") {
				const itemList = this.getData(configuration.grid, configuration.item);
				if(itemList.length > 0) {
					this.view.exportDataModal._style = modalStyle;
					this.view.exportDataModal._caller = caller;
					this.view.exportDataModal._name = name;
					this.view.exportDataModal._itemSelected = itemList;
					this.view.exportDataModal._conf = configuration;
					this.view.exportDataModal._multiGroup = multiGroup;
					this.$forceUpdate();
					this.$modal.show('export-form-modal');
				} else {
					Util.showErrorNotification({ title: t('please_select_an_item_to_export')});
				}
			} else {
				this.view.exportDataModal._style = modalStyle;
				this.view.exportDataModal._caller = caller;
				this.view.exportDataModal._name = name;
				this.view.exportDataModal._conf = configuration;
				this.view.exportDataModal._multiGroup = multiGroup;
				this.$forceUpdate();
				this.$modal.show('export-form-modal');
			}
		},
		saveExport: function(view) {
			this.view.exportDataModal._showLoad = false;
			this.view.exportDataModal._mode = view.exportData.mode;
			this.$forceUpdate();

			const filiServ = this.getFiliServ(view.exportData);
			const itemList = (this.view.exportDataModal._conf.table == "ITGRUPOPRATO") ? this.view.exportDataModal._itemSelected : this.getMultiGroup(view.exportData); 
			const plateDataGrid = {};

			if(this.view.exportDataModal._conf.table == "ITGRUPOPRATO") {
				plateDataGrid.MODE = view.exportData.modeGroup;
				plateDataGrid.GROUPARR = view.exportData.selectedGroupPrat.CDGRUPOPRATO;
			} else {
				plateDataGrid.MODE = null;
				plateDataGrid.GROUPARR = null;
			}
			
			PlateGroupsController.callProcedureExportCadOtimizador(filiServ, this.view.exportDataModal._conf.table, itemList, view.exportData.mode, plateDataGrid).then((response) => {
				if(response.data.length > 0) {
					this.showMessageError(response.data);
				} else {
					this.view.exportDataModal._showLoad = true;
					Util.showSuccessNotification({ title: t('successful_export')});
					this.$modal.hide('export-form-modal');
					this.view.mainPanel.groupGrid.gridConfiguration.reloadData();
				}
			});
		},
		getFiliServ: function(data) {
			const filiServ = [];
			if(data.checkedService) {
				data.services.forEach((service) => { filiServ.push(service.CDLISTA) });
			} else {
				data.selectedService.forEach((service) => { filiServ.push(service.CDLISTA) });
			}
			return filiServ;
		},
		getMultiGroup: function(data) {
			const groups = [];
			if(data.checkedMultGroup) {
				data.groupPrat.forEach((group) => { groups.push(group.NRGRUPOPRATOSERV) });
			} else {
				data.selectedGroupPrat.forEach((group) => { groups.push(group.NRGRUPOPRATOSERV) });
			}
			return groups;
		},
		getGridConfiguration:function(caller) {
			if(caller == 'groupGrid') {
				return { table: 'GRUPOPRATO', grid: this.view.mainPanel.groupGrid, item: 'NRGRUPOPRATOSERV' };
			} else if (caller == 'platesGrid') {
				return { table: 'ITGRUPOPRATO', grid: this.view.mainPanel.platesGrid, item: 'NRITGRUPOPRATOSERV' };
			}
		},
		getData:function(grid, item) {
			const arr = [];
			const nodes = grid.gridConfiguration.gridControl.getSelectedRows();
			nodes.forEach((row) => arr.push(row[item]));
			return arr;
		},
		buildMessage:function(data) {
			let message = [];
			data.forEach((error) => {
				let msg = error.DSERRO;
				msg = msg.replace('_MSGSTA_CONSISTE_GRUPOPRATO', '');
				msg = msg.replace("_MSGEND_", "");
				msg = msg.split("$$");
				message.push({ CDFILIAL: msg[1], CDSERVFILI: msg[2], CDGRUPRAT: msg[3] });
			});
			return message;
		},
		showMessageError:function(data) {
			this.view.exportDataModal._showLoad = true;
			const messages = this.buildMessage(data);
			const typeMessage = data[0].DSERRO.split("$")[0];
            this.$modal.show({
                template:`
					<div class="validity-form-root" style="margin: 0; padding: 25px; width: calc(100% - 50px);"> 
						<div v-show="typeMessage != '_MSGSTA_CONSISTE_PRATO'">
							<h3 class="title"> Erros na Exportação: Grupos de Pratos não associados ao serviço destino </h3>
							<div style="max-height: 500px; overflow: auto; padding: 30px 0; width: 100%;">
								<span v-for="message in messages" style="display:block; margin: 10px;"> Unidade: {{message.CDFILIAL}} Serviço: {{message.CDSERVFILI}} 
								Grupo de Prato: {{message.CDGRUPRAT}}</span>
							</div>
						</div>

						<div v-show="typeMessage == '_MSGSTA_CONSISTE_PRATO'"> 
							<h3 class="title"> Erros na Exportação: Prato local não existe na unidade destino </h3>
							<div style="max-height: 500px; overflow: auto; padding: 30px 0; width: 100%;">
								<span v-for="message in messages" style="display:block; margin: 10px;"> Unidade: {{message.CDFILIAL}} Serviço: {{message.CDSERVFILI}} 
								Prato: {{message.CDGRUPRAT}}</span>
							</div>
						</div>

                        <div>
                            <button class="button" style="margin: 15px auto; display: block; min-width: 200px;" @click="close"> OK </button>
                        </div>
                    </div>
                `,
                props: ['messages', 'typeMessage'],
                methods:{
                    close(){this.$emit('close');}
                }
            }, {messages, typeMessage}, {
                height:'auto',
                width:'69%',
            });
		}
	}
};

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">

	.v--modal-overlay{
		z-index: 21;
	}

	#collapsible-panel.collapsible-panel-fullscren{
		position: fixed;
    	left: 100px;
		z-index: 2;
		background-color: white;
    	width: calc(100vw - 125px);
		padding: 20px 15px;
		border-radius: 0;
		padding-top: 0px;
		margin:0;

		#panel-header{
			.up-arrow, .down-arrow{
				display: none;
			}
		}

		#panel-content{
			.ag-grid-instance{
				height: calc(100vh - 126px);
			}
		}
	}

	.select-350{
		.v-select ul{
			width: 350px;
			z-index: 6;
		}
	}

	.groupless-group-dropdown-hint{
		display: inline-flex;
		align-items: center;
		gap: 4px;
		color: #8a94a6;
		font-size: .78rem;
		font-style: italic;
		opacity: .9;

		i {
			font-size: .7rem;
			opacity: .85;
		}
	}
</style>
<style scoped lang="less">
#plate-groups{
	height: 100vh;
	width: 100vw;
	display: flex;
	
	.grid-button{
		margin-top: 3px;
		font-size: .9rem;
		padding: 6px 13px;
	}

	.screen-container{
		height: 100vh;
		overflow-y: scroll;
		overflow-x: hidden;
		flex: 1;
		min-width: 0;
		box-sizing: border-box;
	}

	.double-grid-container{
		display: flex;
		justify-content: space-around;
		padding-bottom: 5px;

		div.half-grid{
			width: 49%;
			position: relative;
			// height: 430px;

			.grid-overlay{
				position: absolute;
    			top: 0;
				height: 100%;
				width: 100%;
				background: rgba(0, 0, 0, 0.451);
				display:flex;
				align-items: center;
				justify-content: center;

				span{
					width:100%;
					text-align:center;
					text-shadow: -1px 1px rgba(255, 255, 255, 0);
					font-size: 1.3rem;
					color: rgba(255, 255, 255, 0.85);
				}

				.grid-overlay-loading {
					display: flex;
					flex-direction: column;
					align-items: center;
					gap: 10px;
				}

				.grid-overlay-spinner {
					width: 34px;
					height: 34px;
					border: 4px solid rgba(255,255,255,.6);
					border-top-color: #2a8fdd;
					border-radius: 50%;
					animation: spin-overlay .9s linear infinite;
				}

			}
		}

	}
	.double-grid-btn-container{
		padding-bottom: 3px;
		display: flex;

		span{
			width: calc(50% - 10px);
			margin: 0 5px;
		}

		.button.disabled{
			background-color: gray;
			pointer-events: none;
		}

		.right-grid-button-container {
			display: inline-flex;
			justify-content: space-between;
			align-items: center;

			> .button-div {
				margin-top: 0;
				gap: 1rem;
				align-items: center;
				flex-wrap: wrap;
			}

			.fullscreen-button.button-div {
				margin-top: 0;
				gap: .75rem;
			}
		}
	}

	.gray-button{
		.grid-button;
		box-shadow: none;
		background-color: #dedede;
		color: #383838;
		&:hover{
			background-color: gray;
			color:white;
		}
	}

	.button-container-align-left, .button-container-align-right{
		display: inline-block;
		flex: 1;
	}

	.button-container-align-right{
		text-align: right;
		&.full-width{
			width: 100%;
		}
	}

	.low-height-grid{
		height: 200px;
	}

		.recipe-grid{
			height: 100%;
		}

		.groupless-row-linking-indicator{
			display: inline-flex;
			align-items: center;
			justify-content: center;
			width: 100%;
			color: #2a8fdd;
			font-size: .95rem;
		}

		.add-plates-modal-grid.ag-grid-instance{
			height: 48vh;
			min-height: 320px;
		}

		.add-plates-floating-loader {
		position: fixed;
		bottom: 50px;
		right: 18px;
		z-index: 12;
		display: inline-flex;
		align-items: center;
		gap: 10px;
		padding: 10px 14px;
		border-radius: 8px;
		background: rgba(33, 33, 33, .92);
		color: #fff;
		font-size: .88rem;
		pointer-events: none;
	}

	.grid-overlay-fade-enter-active,
	.grid-overlay-fade-leave-active,
	.floating-loader-fade-enter-active,
	.floating-loader-fade-leave-active {
		transition: opacity .2s ease;
	}

	.grid-overlay-fade-enter,
	.grid-overlay-fade-leave-to,
	.floating-loader-fade-enter,
	.floating-loader-fade-leave-to {
		opacity: 0;
	}

	.loader-dot {
		width: 10px;
		height: 10px;
		border-radius: 50%;
		background: #9bd1ff;
		animation: pulse-loader .9s ease-in-out infinite;
	}

	@keyframes pulse-loader {
		0%, 100% { transform: scale(0.8); opacity: .6; }
		50% { transform: scale(1.2); opacity: 1; }
	}

	@keyframes spin-overlay {
		from { transform: rotate(0deg); }
		to { transform: rotate(360deg); }
	}
	
	.button-container{
		display: flex;
    	justify-content: space-between;
	}
}

</style>
